// @flow
/**
 * Created by ivo on 27.01.17.
 */

import {vsprintf} from 'sprintf-js';
import {trans_table, lang_decimalSep} from "./Grobot/Global";


// Global language setting:
let lang_idx = 0;


export function setLanguageIdx(idx: number): void {
    lang_idx = idx;
}


export function getLanguageIdx(): number {
    return lang_idx;
}


export function getDecimalSep(): string {
    let sep = lang_decimalSep[lang_idx];
    if (!sep) return '.';
    return sep;
}


/**
 * Tekstide tõlkimine.
 *
 * Tõlketabel on toodud failis /locales/trans_table.js
 */
export function trans(s: string): string {
    try {
        if (trans_table[s]) {
            let tt = trans_table[s][lang_idx];
            if (tt) return tt;
            return s;
        } else {
            return s;
        }
    } catch (err) {
        return s;
    }
}

function t(arg1: string, ...args: Array<any>): string {
    return (args.length > 0 ? vsprintf(trans(arg1), args) : trans(arg1));
}

export default t;
